import { render, staticRenderFns } from "./StarsScore.vue?vue&type=template&id=6aa11643"
import script from "./StarsScore.vue?vue&type=script&lang=js"
export * from "./StarsScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports